// 用于不同站点生成不同的ID
const getLocaleStringA = () => {
    const originA = location.origin || '';
    const pathnameA = location.pathname || '';
    if (['https://www.ecoflow.com', 'https://homebattery.ecoflow.com', 'http://forum.ecoflow.com'].includes(originA)) {
        return pathnameA.slice(1, 3);
    } else {
        // shopify 站点
        return originA.slice(8, 10);
    }
};
// 每天生成的ID都不一样
const getTodayString = () => {
    const dateA = new Date();
    const yearB = dateA.getFullYear();
    const monthB = dateA.getMonth();
    const dateB = dateA.getDate();
    return `${yearB}-${monthB}-${dateB}`;
};
// 接口整合
export const getBrowserIdFromCanvas = async (paramA?: any) => {
    const paramB = paramA || {};
    const textIdA1 = paramB.textIdA1 || '';
    if (typeof window === 'undefined') {
        return '';
    }
    // 获取 Canvas 数据
    const canvasData: string = getHighEntropyCanvasData();

    // navigator 特性-start
    const navigator_array = [];
    for (const key in navigator) {
        if (key === 'storage') {
            continue;
        }
        const value = (navigator as any)[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            navigator_array.push(value);
        }
    }
    const navigator_text = navigator_array.join('-');
    // navigator 特性-end

    // screen 特性-start
    const screen_array = [];
    for (const key in screen) {
        const value = (screen as any)[key];
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            screen_array.push(value);
        }
    }
    const screen_text = screen_array.join('-');
    // screen 特性-end

    // 使用时间-start
    const dateA1 = new Date(1749457632923); //固定一个时间
    const DividendsObjB: any = {};
    if (dateA1.toLocaleDateString) {
        DividendsObjB.toLocaleDateString = dateA1.toLocaleDateString();
    }
    if (dateA1.toLocaleString) {
        DividendsObjB.toLocaleString = dateA1.toLocaleString();
    }
    if (dateA1.toTimeString) {
        DividendsObjB.toTimeString = dateA1.toTimeString();
    }
    if (dateA1.toUTCString) {
        DividendsObjB.toUTCString = dateA1.toUTCString();
    }
    if (dateA1.toLocaleTimeString) {
        DividendsObjB.toLocaleTimeString = dateA1.toLocaleTimeString();
    }
    const DividendsTextB = Object.values(DividendsObjB).join('-');
    // 使用时间-end

    // 其它
    const otherA1Obj: any = {};
    try {
        otherA1Obj.effectiveType = ((navigator as any).connection || {}).effectiveType; // 网络类型
        const timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown'; // 时区名称
        otherA1Obj.timeZone = timeZone; // 时区名称
        const timezoneOffset: number = new Date().getTimezoneOffset(); // 时区偏移量（分钟）
        otherA1Obj.timezoneOffset = timezoneOffset; // 时区偏移量（分钟）
    } catch (error) {}
    const otherA1Text = Object.values(otherA1Obj).join('-');

    // 今天年月日-用于每日更新ID
    const todayValueA = getTodayString();
    // 站点-不同的站点生成的ID不一样
    const localeValueA = getLocaleStringA();
    // webgl
    const webglMsgA = getWebGLFingerprint();
    const textIdA1_2 = textIdA1 || '';
    // 整合所有特性数据
    const data: string = [canvasData, navigator_text, screen_text, otherA1Text, DividendsTextB, todayValueA, webglMsgA, localeValueA, textIdA1_2].join('###');

    // 使用 SHA-256 生成哈希
    const device_id = await hashSHA256(data);
    return device_id;
};

/**
 * 使用 Web Crypto API 计算 SHA-256 哈希值
 * @param data - 输入字符串
 * @returns 哈希值的十六进制字符串
 */
async function hashSHA256(data: string): Promise<string> {
    const encoder = new TextEncoder();
    const buffer = encoder.encode(data);
    const hashBuffer = await crypto.subtle?.digest('SHA-256', buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

function getWebGLFingerprint(): string {
    try {
        const canvas = document.createElement('canvas');
        const gl: any = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) return '';

        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        const vendor = debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : '';
        const renderer = debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : '';

        return `vendor:${vendor};renderer:${renderer}`;
    } catch {
        return '';
    }
}
// 使用canvas生成差异信息
function getHighEntropyCanvasData(): string {
    try {
        const canvas = document.createElement('canvas');
        canvas.width = 400;
        canvas.height = 300;
        const ctx = canvas.getContext('2d');
        if (!ctx) return '';

        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        const fonts = ['18px Arial', '20px Courier', '22px Georgia'];
        const DividendsObjA = {
            fr: 'Dividendes élevés',
            de: 'Dividenden',
            kr: '높은 배당금',
            cis: 'Высокие дивиденды',
            arab: 'أرباح عالية', //阿拉伯
            persia: 'تقسیم', //波斯
            belarus: 'Дывідэнты',
            Sanskrit: 'विभागाः', //梵语
            Thai: 'เงินปันผลสูง', //泰语
            baluchi: 'غیر فعال کتن ذخیره په ـدیسک', //俾路支语
        };
        const langs = Object.values(DividendsObjA);

        langs.forEach((text, i) => {
            ctx.font = fonts[i % fonts.length];
            ctx.fillStyle = `hsl(${i * 36}, 70%, 50%)`;
            ctx.globalAlpha = 0.85;
            const y = 30 + i * 24;
            ctx.fillText(text, 10, y);
            ctx.strokeStyle = '#333';
            ctx.strokeText(text, 10, y);
        });

        // 旋转一行特殊字符
        ctx.save();
        ctx.translate(200, 280);
        ctx.rotate(-0.12);
        ctx.font = '20px Times';
        ctx.fillStyle = '#993399';
        ctx.fillText('🌍📈 高熵指纹测试 ©', -80, 0);
        ctx.restore();

        return canvas.toDataURL();
    } catch {
        return '';
    }
}
